export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13270.d6656b60.jpg";